module.exports = __webpack_public_path__ + "img/edge_divers_voiture.36ecbbd3.svg";